import EventService from 'Services/EventService'

export default {

    namespaced: true,

    state: {
        events: [],
        event: {},
        eventPreview: {
            office: {},
            patient: {},
            visit: {}
        }
    },

    getters: {
        event: state => state.event,
        eventPreview: state => state.eventPreview,
        events: state => state.events
    },

    mutations: {
        SET_EVENT(state, event) {
            state.event = event
        },
        SET_EVENT_PREVIEW(state, eventPreview) {
            state.eventPreview = eventPreview
        },
        SET_EVENTS(state, events) {
            state.events = events.map((event) => {
                if (event.rendering) {
                    return {
                        start: event.start,
                        end: event.end,
                        rendering: event.rendering
                    }
                }
                return {
                    id: event.id,
                    start: event.start,
                    end: event.end,
                    title: event.type === 'block' ? 'Blokada' : (event.patient.first_name + ' ' + event.patient.last_name),
                    editable: (event.visit_id === null),
                    color: event.type === 'block' ? '#ea9343' : ((event.visit_id !== null) ? '#cfcfd3' : ((event.type === 'mobile') ? '#1A173B' : '#56BC6F'))
                }
            })
        }
    },

    actions: {
        FETCH_EVENTS({commit}, payload) {
            payload.with = 'patient'
            return EventService.list(payload).then((response) => {
                commit('SET_EVENTS', response.data.data)
                return response
            })
        },
        FETCH_EVENT({commit}, eventId) {
            return EventService.get(eventId).then((response) => {
                commit('SET_EVENT', response.data.data)
                return response
            })
        },
        FETCH_EVENT_PREVIEW({commit}, eventId) {
            return EventService.get(eventId, {with: 'visit,office,patient'}).then((response) => {
                commit('SET_EVENT_PREVIEW', response.data.data)
                return response
            })
        },
        ADD_EVENT({state}) {
            return EventService.store(state.event).then((response) => {
                commit('SET_EVENT', response.data.data)
                return response
            })
        },
        UPDATE_EVENT({state, commit}) {
            return EventService.update(state.event).then((response) => {
                commit('SET_EVENT', response.data.data)
                return response
            })
        },
        REMOVE_EVENT(context, payload) {
            return EventService.delete(payload.id, payload.query)
        },
        RESET_EVENT({commit}) {
            commit('SET_EVENT', {})
        },
        RESET_EVENTS({commit}) {
            commit('SET_EVENTS', [])
        }
    }

}
